import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["template", "container"]

  connect() {
    Sortable.create(this.containerTarget, {
      handle: "[data-sort-handle]",
      animation: 150,
      onEnd: () => this.updateOrder(),
    })
  }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.updateOrder()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-form-target='row']")
    const destroyInput = row.querySelector("input[name*='_destroy']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
    this.updateOrder()
  }

  updateOrder() {
    const rows = this.containerTarget.querySelectorAll("[data-nested-form-target='row']")
    let index = 0
    rows.forEach((row) => {
      if (row.style.display === "none") return
      const orderInput = row.querySelector("input[name*='[order]']")
      if (orderInput) orderInput.value = index++
    })
  }
}
